export const getWatchFields = (watch) => {
  const passwordCheck = watch('password')
  const confirmPasswordCheck = watch('confirmPassword')
  return { passwordCheck, confirmPasswordCheck }
}
